/**
 * The result set operation that is saved with a dashboard/tile.
 * This is the new streamlined API format.
 */
export interface VirtualClinicAnalysisOperatingNumberResultSetOperation {
  name: string;
  parameters: string[];
}

/**
 * The result set operation option returned from the backend API.
 * Used for populating the dropdown in the UI.
 */
export interface VirtualClinicAnalysisOperatingNumberResultSetOperationOption {
  fieldName: string;
  displayName: { [locale: string]: string };
  possibleParameters: VirtualClinicAnalysisOperatingNumberResultSetOperationParameter[];
}

/**
 * Parameter option returned from the backend API for result set operations.
 * Used for UI display purposes.
 */
export interface VirtualClinicAnalysisOperatingNumberResultSetOperationParameter {
  name: string;
  displayName: { [locale: string]: string };
  optional: boolean;
}

/**
 * The "none" option for the result set operation dropdown.
 * Combines both Option (for dropdown) and ResultSetOperation (for saved value) interfaces.
 */
export const RESULT_SET_OPERATION_NONE: VirtualClinicAnalysisOperatingNumberResultSetOperationOption &
  VirtualClinicAnalysisOperatingNumberResultSetOperation = {
  fieldName: 'none',
  name: 'none',
  displayName: { de: 'Keine' },
  possibleParameters: [],
  parameters: [],
};
